module.exports = __webpack_public_path__ + "static/media/download_button_hovered.f87754d2.jpeg";